import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from '@reach/router';
import PropTypes from 'prop-types';

const RouteContext = React.createContext();
const useRouteContext = () => useContext(RouteContext);

const RouteProvider = ({ children }) => {
  const router = useLocation();
  const [previousPath, setPreviousPath] = useState('/');

  useEffect(() => {
    return () => setPreviousPath(router.pathname);
  }, [router]);

  return (
    <RouteContext.Provider value={{ previousPath }}>
      {children}
    </RouteContext.Provider>
  );
};

RouteProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default RouteProvider;
export { RouteContext, useRouteContext };
